import { createRouter, createWebHistory } from "vue-router";
import GuestChat from './components/GuestChat.vue';
import Login from './components/LoginPage.vue';
import Signup from './components/SignupPage.vue';
import ChatbotPage from './components/ChatPage.vue';
import NotFound from './components/NotFound.vue';

const routes = [
  { path: '/:paramValue/guest', component: GuestChat, name: 'GuestChat', props: true},
  { path: '/:paramValue/login', component: Login, name: 'Login', props: true },
  { path: '/:paramValue/signup', component: Signup, name: 'Signup', props: true },
  { path: '/:paramValue/chatpage', component: ChatbotPage, name: 'ChatbotPage', props: true },
  {
    path: '/:pathMatch(.*)*', // Use the parameter with a custom regexp
    component: NotFound
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to check login status before each route change
router.beforeEach((to, from, next) => {
  const userToken = sessionStorage.getItem('user_token');
  
  // If the user is already logged in, redirect to ChatbotPage for login and signup routes
  if (userToken && (to.name === 'Login' || to.name === 'Signup')) {
    next({ name: 'ChatbotPage', params: { paramValue: to.params.paramValue } });
  } else {
    next();
  }
});

export default router;
